import { UgcTab } from "../typings";

// 常量定义
export const MIN_TEAM_LEVEL = 45; // 组队集结最低角色等级要求

export const taskText = [
  {
    key: "task_daily_login", // 对应接口 taskId
    subTaskId: "sub_daily_login", // 对应接口 subTaskId
    title: "每日登錄遊戲",
    score: 10,
    descript: "每日參與限制1次",
    login: true,
    hideGoButton: true, // 新增：只展示已完成、未完成，不出现去完成按钮
  },
  {
    key: "task_daily_share", // 对应接口 taskId
    subTaskId: "sub_daily_share", // 对应接口 subTaskId
    title: "每日分享活動頁面",
    score: 10,
    descript: "每日參與限制1次"
  },
  {
    key: "task_reserve_external", // 对应接口 taskId
    subTaskId: "sub_reserve_external", // 对应接口 subTaskId
    title: "參與新服預約",
    score: 100,
    descript: "活動期間參與限制1次",
    redirectUrl: `https://auto-page.gnjoy.hk/ro_newserver_02/`,
  },
  {
    key: "task_team_rally", // 对应接口 taskId
    subTaskId: "sub_team_member", // 对应接口 subTaskId
    title: "組隊集結",
    descript: `(角色等級≥${MIN_TEAM_LEVEL}級時可參與)`,
    tips: "※創建/加入隊伍後不可退出",
    children: [
      {
        levelId: "level_team_3", // 对应接口 levelId
        level: 3,
        score: 20,
        title: "隊伍人數達到3人",
        descript: "活動期間參與限制1次",
      },
      {
        levelId: "level_team_5", // 对应接口 levelId
        level: 5,
        score: 40,
        title: "隊伍人數達到5人",
        descript: "活動期間參與限制1次",
      },
      {
        levelId: "level_team_7", // 对应接口 levelId
        level: 7,
        score: 60,
        title: "隊伍人數達到7人",
        descript: "活動期間參與限制1次",
      },
      {
        levelId: "level_team_10", // 对应接口 levelId
        level: 10,
        score: 80,
        title: "隊伍人數達到10人",
        descript: "活動期間參與限制1次",
      },
    ],
  }
];

export const awardConfig = {
  Thanks: "謝謝參與",
  Title: "稱號",
  Avatar: "頭像框",
  PhoneHolder: "巴風特手機支架",
  CanvasBag: "大世界帆布包",
  FridgeMagnet: "初心者裝死冰箱貼",
  Calendar: "波利萬年曆",
  WaistPillow: "RO職業書本腰靠",
  Headwear: "頭飾",
  ScoreTitleLv1: "稱號：初心者腦洞好大喔",
  ScoreTitleLv2: "稱號：RO大世界入股不虧",
  ScoreTitleLv3: "稱號：不裝了我是創世神",
};
